<template>
  <b-modal ref="modal" size="lg" lazy :hide-footer="true" title="Final Steps">
    <div class="p-3">
      <b-row class="mb-4">
        <b-col sm="6">
          <!-- <h5><b>Batch Name</b></h5>
          <b-input-group :prepend="`GS_${user.id}_`"> -->
          <b-input-group class="default">
            <b-input id="batch_name" name="city" type="text" :class="[{ 'is-invalid': !batch_name },]" v-model="batch_name"
              :maxlength="50" placeholder="Batch Name" @input="onSlugify"></b-input>
          </b-input-group>
        </b-col>
        <b-col sm="12">
          <p v-if="actual_name" class="mt-2">File Name: {{ actual_name }}</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <h5><b>Confirm Paper Settings</b></h5>
        </b-col>

        <b-col md="6">
          <p>Thermal Printer (Zebra, DYMO, Eltron, etc.)</p>
          <b-img src="/images/print_preview/thermal.png"
            style="max-width: 10rem; max-height: 10rem; margin-bottom: 1rem;"></b-img>
          <b-form-group label="Label Layout">
            <b-form-radio v-model="shipping_label_format" size="sm" inline name="paper_type" value="DOC_4X6">4x6 Label
              Roll</b-form-radio>
            <b-form-radio v-model="shipping_label_format" size="sm" inline name="paper_type" value="DOC_4X8">4x8 Label
              Roll</b-form-radio>
          </b-form-group>

          <div style="padding-left: 2rem;">
            <b-img v-show="shipping_label_format == 'DOC_4X6'" style="width: 8rem;" src="/images/print_preview/1.png" />
            <span v-show="shipping_label_format == 'DOC_4X8'">
              <b-row>
                <b-col lg="5">
                  <b-img style="width: 8rem;" src="/images/print_preview/2.png" />
                </b-col>
                <b-col lg="7">
                  <small>
                    <strong>2” Doc Tab will include</strong>
                    <ul style="padding-left: 15px;">
                      <li>Ship From Company &amp; Name</li>
                      <li>Ship To Company &amp; Name</li>
                      <li>Tracking #</li>
                      <li>Ref ID</li>
                      <li>Order #</li>
                      <!-- <li>Total Cost</li> -->
                      <li>Description</li>
                      <li>Custom Field 1</li>
                      <li>Custom Field 2</li>
                      <li>Printed Date</li>
                    </ul>
                  </small>
                </b-col>
              </b-row>
            </span>
          </div>
        </b-col>

        <b-col md="6">
          <p>Laser/Inkjet (HP, Canon, Epson, etc.)</p>
          <b-img src="/images/print_preview/laser.png"
            style="max-width: 10rem; max-height: 10rem; margin-bottom: 1rem; "></b-img>
          <b-form-group label="Label Layout">
            <b-form-radio v-model="shipping_label_format" size="sm" inline name="paper_type" value="DOC_8X11">8.5x11
              Paper Landscape</b-form-radio>
          </b-form-group>
          <div style="padding-left: 2rem;">
            <b-img v-show="shipping_label_format == 'DOC_8X11'" style="width: 8rem;" src="/images/print_preview/4.png" />
          </div>
        </b-col>
      </b-row>

      <b-button :disabled="!batch_name" class="float-right btn-blue" size="sm" @click="printOrders"><i
          class="fa fa-barcode fa-lg" aria-hidden="true"></i> Process Label</b-button>
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
.print-container {
  position: relative;

  .card {
    margin-bottom: 1.5rem;

    .card-header {
      color: #fff;
      font-size: 0.95rem !important;
      padding: 0.10rem 1rem;
    }
  }

  .table {

    th,
    td {
      font-size: .95rem;
      padding: 0.5rem;
    }
  }
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import slugify from "slugify";

export default {
  props: ['selected', 'printed_on'],
  data() {
    return {
      batch_name: '',
      actual_name: '',
      isLoading: false,
      allowTestPrint: true,
      shipping_label_format: 'DOC_4X6',
      return_detail: {},
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  mounted() { },
  methods: {
    ...mapActions(["refreshUser", "addPrintJob"]),
    show(data) {
      this.return_detail = data
      // console.log('Return detail: ', data);
      this.$refs.modal.show();
    },
    onSlugify() {
      this.actual_name = slugify(this.batch_name);
    },
    printOrders() {
      this.$emit('print', {
        paper: this.shipping_label_format,
        bName: this.actual_name,
        printed_on: this.printed_on || 'Import',
        returnDetail: this.return_detail
        // base64: true,
      });
      this.$router.push('/orders/batch-label-history');
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Import/PrintingProcess.vue